// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"c90f5c02","63":"918448c4","167":"076ed6e8","338":"420df9d8","435":"a87bff1d","437":"e06bcc3e","453":"de196920","562":"1f06820a","581":"a9b2d399","724":"b625c6f1"}[chunkId] + ".chunk.js";
};